export const TRONC_POTS = {
    TRONC_BONUS: "TRONC_BONUS",
    TRONC_FIXED_AMOUNT: "TRONC_FIXED_AMOUNT",
    TRONC_POINTS: "TRONC_POINTS",
    TRONC_FIXED_RATE: "TRONC_FIXED_RATE"
};

export const TRONC_POINT_PERIOD_TYPE = {
    DAILY: 'DAILY',
    PAY_PERIOD: 'PAY_PERIOD',
};

export const TRONC_MODES = {
    FIXED: 'FIXED',
    HYBRID: 'HYBRID',
};

export const TRONC_RATE_VISIBILITY = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};

export const PAY_PERIOD_DISTRIBUTION_MODES = {
    FULL: 'FULL',
    WEEKLY: 'WEEKLY',
};

export const TRONC_SOURCE_STATUS = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED',
};

export const CENTS_IN_CURRENCY = 100;